import theme from "@/styles/theme";
import styled from "styled-components";

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 1vw;
  margin-top: 1vh;
  margin-bottom: 1vh;
  @media (${theme.devices.tablet}) {
    row-gap: 1vh;
    flex-direction: column;
  }
`;

export const DgContainer = styled.div`
  @media (${theme.devices.tablet}) {
    overflow-y: auto;
    max-height: 60vh;
    width: fit-content;
  }
`;
export const BtnContainer = styled.div`
  width: 200px;
  @media (${theme.devices.tablet}) {
    width: 100%;
  }
`;
